import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Help_Ansprechpartner_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { numberHash, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Model, Msg, Model_Init } from "./Types.fs.js";
import { request, Loaded } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { toggle } from "../../../../Bfs.Web.Portale/Helpers.fs.js";
import { List_distinct } from "../../../fable_modules/fable-library-js.4.19.0/Seq2.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";

export function Http_getAnsprechpartner() {
    const response = fetch("/api/ansprechpartner", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Help_Ansprechpartner_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(page, user, lastModel) {
    return [Model_Init(), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    let Expanded;
    switch (msg.tag) {
        case 1:
            return [new Model(Loaded(msg.fields[0]), model.Touched, model.Expanded), Cmd_none()];
        case 2: {
            const i = msg.fields[0] | 0;
            return [(Expanded = toggle(i, model.Expanded), new Model(model.Ansprechpartner, List_distinct(append(singleton(i), model.Touched), {
                Equals: (x_1, y) => (x_1 === y),
                GetHashCode: numberHash,
            }), Expanded)), Cmd_none()];
        }
        default:
            return [new Model(new Remote$1(1, []), model.Touched, model.Expanded), request(Http_getAnsprechpartner, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
